import React from "react";

import { Tooltip } from "@material-ui/core";
import { orange } from "@material-ui/core/colors";

import { LinkOffIcon } from "./iconography";

export const ProductLinkIcon = ({ record, ...props }) => {
  if (!record?.productId) {
    return (
      <Tooltip title="Not linked to Product" placement="right" arrow>
        <LinkOffIcon fontSize="medium" style={{ color: orange[600] }} />
      </Tooltip>
    );
  }
  return null;
};
